import React, { Component } from 'react'
import { Page } from 'react-pdf'
import { Document } from 'react-pdf/dist/entry.webpack'
import { Alert, Spin, Button } from 'antd'
import { api } from '../../services'
import FileSaver from 'file-saver'
import 'react-pdf/dist/Page/AnnotationLayer.css'

export default class extends Component {
  state = {
    numPages: null,
    data: null,
    error: false,
    meta: {
      name: null,
      extension: null,
      description: null,
      size: null,
      timestampCreated: null,
      timestampModified: null
    }
  }

  token = null
  ref = null

  docRef = (n) => {
    this.ref = n
  }

  componentDidMount () {
    this.token = this.props.match.params.token

    if (this.token) {
      this.fetchFileMeta(this.token)
      this.fetchFile(this.token)
    }
  }

  fetchFileMeta (token) {
    api.share.meta(token).then(response => {
      this.setState({ meta: response.data.result })
    }).catch(() => {
      this.setState({
        error: true
      })
    })
  }

  fetchFile (token) {
    const { error } = this.state

    if (error) {
      return
    }

    api.share.open(token).then(response => {
      this.setState({
        data: response.data
      })
    })
  }

  handleDownload = () => {
    this.setState({
      download: true
    })

    api.share.download(this.token).then((response) => {
      const blob = new Blob([response.data], {
        type: 'application/pdf'
      })

      FileSaver.saveAs(blob, this.state.meta.name + '.' + this.state.meta.extension)
    }).then(() => {
      this.setState({
        download: false,
        keys: [],
        rows: []
      })
    })
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages })
  }

  render () {
    const { numPages, data, error, meta } = this.state

    return (
      <div className='viewer'>
        { !error &&
        <div className='viewer-header viewer__header'>
          <div className='viewer-header__inner'>
            <div className='viewer-header__side'>
              { meta.name && <div className='viewer-header__filename'>{ meta.name + '.' + meta.extension }</div> }
            </div>
            <div className='viewer-header__side viewer-header__side_right'>
              { numPages && <div className='viewer-header__pages'>{ numPages } { numPages > 1 ? 'pages' : 'page' }</div> }
              <div className='viewer-header__button'>
                { !error && <Button type='indigo' onClick={this.handleDownload}>Download</Button> }
              </div>
            </div>
          </div>
        </div>
        }
        <div className='viewer-body viewer__body'>

          { (data || !error) && (!data || error) && <div className='viewer-body__spin'><Spin size='large' tip='Loading...' /></div> }

          <div className='viewer-body__inner'>
            { error && <Alert message='File not found' className='viewer-body__alert' type='error' /> }
            <div className='viewer-body__document' width='100%' ref={this.docRef}>
              { data &&
              <Document
                file={{ data }}
                onLoadSuccess={this.onDocumentLoadSuccess}
              >
                { Array.from(Array(numPages).keys()).map((page, index) =>
                  <div className='viewer-page viewer-body__page' key={index}>
                    <Page
                      width={this.ref.getBoundingClientRect().width - 40}
                      pageNumber={page + 1}
                      rotate={0}
                      renderTextLayer={false}
                    />
                  </div>
                )}
              </Document> }
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Viewer/Viewer.jsx